import LoginForm from "../components/loginPage/LoginForm";
import Logo from "../components/mainPage/Logo";
import '../style/components/login.css';
import KeyIcon from '../docs/light/key.png'

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from "swiper/modules";


import 'swiper/css';
import 'swiper/css/pagination';


import Advatange from "../components/loginPage/advatage";

import PaymentOnline from '../data/payment.json';
import OnlinePay from "../components/loginPage/onlinePay";
import { useContext, useState } from "react";
import { config } from "../context/config";

export default function Login() {
    const [showId, setShowId] = useState(false);
    const {devKey, setDevKey} = useContext(config);

    return (
        <div className="login flex flex-center-center">
            <div className="box flex flex-align-item-center">
                <div className="welcome-cst ch inline">
                    <Logo width="60" />
                    <Swiper
                        spaceBetween={50}
                        slidesPerView={1}
                        pagination={true}
                        autoplay={{
                            delay: 5500,
                            disableOnInteraction: false
                        }}
                        modules={[Autoplay, Pagination]}
                        >
                        <SwiperSlide>
                            <Advatange  
                                title="very speed and make all tasks in a moments" 
                                desc="Our program is fast, accomplishes tasks in moments, and is easy for employees to use." 
                                bg={require("../docs/advantage_icon/f1.png")} 
                            />
                        </SwiperSlide>
                        <SwiperSlide>
                            <Advatange 
                                title="work on any device" 
                                desc="Our program can run easily on any device and is optimized for dimensions to be user-friendly." 
                                bg={require("../docs/advantage_icon/f2.png")} 
                            />
                        </SwiperSlide>
                        <SwiperSlide>
                            <Advatange 
                                title="Here we Here to make the best for you" 
                                desc="you can change your life and control anything in your company login and begin now" 
                                bg={require("../docs/advantage_icon/f3.png")} 
                            />
                        </SwiperSlide>
                    </Swiper>
                </div>
                <div className="form-cst ch">
                    {showId ?
                        <div className="dev-token">
                            <div className="right">
                                <button onClick={()=>setShowId(false)}>x</button>
                            </div>
                            <input maxLength={16} onChange={(e) => setDevKey(e.target.value)} value={devKey} className="line" type="text" placeholder="put device ID" />
                            <img alt="" src={KeyIcon} width={'15px'} />
                            <p className="note warning">
                                Your ID will be sent via email or provided by our customer service team.
                                If you have not received it, please contact customer service through the hotline.
                            </p>
                        </div>
                        :
                        <div>
                            <button onClick={()=> setShowId(true)}>Device key <img alt="" src={KeyIcon} width={'10'} /></button>
                        </div>
                    }
                    <h2 className="text-weight-light">أهلا بعودتك</h2>
                    <p>بدأ شغلك بسرعة وكفاءة واحترافية!</p>
                    <p>خدمتك 24/7، لأي استفسار أو مساعدة أينما كنت</p>
                    <LoginForm mode="login" enableForgetPass={true} />
                    <div className="payment-online">
                        <h5 className="center">ادفع بسهولة الأن مع طرق دفع بسيطة</h5>
                        <div className="methods flex flex-center-center">
                            {PaymentOnline.map((e, i) => 
                                <OnlinePay key={i} name={e.title} link={e.link} img={e.logo} />
                            )}
                        </div>
                        <div className="center policy-guid">
                            <h6>يرجى قراءة الأرشادات و القوانين التابعة للنظام</h6>
                            <p>هذا اللينك يحتوي على كل الأرشادات <a href="/">هنا</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}